var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamIcon3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.084 19.25V17.4166C21.0834 16.6042 20.813 15.815 20.3152 15.1729C19.8175 14.5308 19.1206 14.0722 18.334 13.8691",
    stroke: "#AF3208",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5827 19.25V17.4167C15.5827 16.4442 15.1964 15.5116 14.5087 14.8239C13.8211 14.1363 12.8885 13.75 11.916 13.75H4.58268C3.61022 13.75 2.67759 14.1363 1.98996 14.8239C1.30232 15.5116 0.916016 16.4442 0.916016 17.4167V19.25",
    stroke: "#AF3208",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 2.86914C15.4547 3.07108 16.1538 3.52978 16.653 4.17293C17.1522 4.81607 17.4232 5.60707 17.4232 6.42122C17.4232 7.23538 17.1522 8.02638 16.653 8.66952C16.1538 9.31266 15.4547 9.77136 14.666 9.97331",
    stroke: "#AF3208",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25065 10.0833C10.2757 10.0833 11.9173 8.44171 11.9173 6.41667C11.9173 4.39162 10.2757 2.75 8.25065 2.75C6.22561 2.75 4.58398 4.39162 4.58398 6.41667C4.58398 8.44171 6.22561 10.0833 8.25065 10.0833Z",
    stroke: "#AF3208",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon3);
export default __webpack_public_path__ + "static/media/teamIcon3.9fea01d7e366ba4848e0790074305637.svg";
export { ForwardRef as ReactComponent };